import React from 'react';
import { MainSkeleton } from '../../../landing.common/main.skeleton';

interface Props {
    isFullScreen?: boolean;
}

/** @deprecated */
export const FormLoader: React.FC<Props> = ({ isFullScreen }) => (
    <MainSkeleton />
);
